// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-ProjectImage----styles-module---wrapper---1uB88","box":"src-components-ProjectImage----styles-module---box---2n14X","fit":"src-components-ProjectImage----styles-module---fit---rutPY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectImage/styles.module.scss
// module id = 49
// module chunks = 139164803332356 182974369400049 213534597649335